import styled from 'styled-components';
import {comum} from '../../../../styles/Themes/light';

export const Container = styled.div`
  padding-bottom: 40px;
  background-color: ${(props: any) => props.theme.colors.interfacePure0};
  border-radius: 8px;
`;

export const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.c2d3748};
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label<{ required?: boolean }>`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${(props: any) => props.theme.colors.c2d3748};
  margin-bottom: 0.5rem;
  display: block;
  position: relative;

  ${props => props.required && `
    &::after {
      content: '*';
      color: ${(props: any) => props.theme.colors.ce53e3e};
      margin-left: 4px;
      font-weight: 700;
    }
  `}
`;

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  height: 48px;
  padding: 0 1rem;
  border: ${props => props.hasError ? '1px solid #E53E3E' : '1px solid #e2e8f0'};
  border-radius: 6px;
  font-size: 0.875rem;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
  }

  &:blur {
    border: ${props => props.hasError ? '1px solid #E53E3E' : '1px solid #e2e8f0'};
  }
`;

export const ErrorMessage = styled.span`
  color: ${(props: any) => props.theme.colors.ce53e3e};
  font-size: 0.875rem;
  margin-top: 4px;
  display: block;
`;

export const ErrorSpacing = styled.span`
  color: ${(props: any) => props.theme.colors.pureWhite};
  font-size: 0.875rem;
  margin-top: 4px;
  display: block;
`;

// Estilos para os selects
export const selectStyles = {
  control: (provided: Record<string, unknown>, state: any) => ({
    ...provided,
    height: 48,
    boxShadow: "none",
    cursor: 'pointer',
    border: state.hasValue && state.selectProps.error 
      ? `1px solid ${comum.colors.primaryRed400}` 
      : '1px solid #EAEEF3',
    '&:hover': {
      border: `1px solid ${comum.colors.interfaceTextGray}`,
    },
  }),
  placeholder: (provided: Record<string, unknown>) => ({
    ...provided,
    color: 'var(--c353a40)',
    fontSize: '16px',
    fontWeight: '400',
  }),
  singleValue: (provided: Record<string, unknown>) => ({
    ...provided,
    color: 'var(--c353a40)',
    fontSize: '16px',
  }),
  option: (provided: Record<string, unknown>) => ({
    ...provided,
    color: 'var(--c5a646e)',
    fontSize: '16px',
    fontWeight: '500',
  }),
  menu: (provided: Record<string, unknown>) => ({
    ...provided,
    zIndex: 3,
  }),
  menuPortal: (provided: Record<string, unknown>) => ({
    ...provided,
    zIndex: 3,
  }),
};

export const selectTheme = (theme: any) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: comum.colors.interfacePure100,
    primary50: comum.colors.interfacePure100,
    primary: comum.colors.interfacePure100,
  },
});

export const selectComponents = {
  IndicatorSeparator: () => null
};